module.exports = __webpack_public_path__ + "static/img/illustratepic_02.1740ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-TW/illustratepic_02.png
// module id = oQbI
// module chunks = 1